import { Component } from '@angular/core';

@Component({
	selector: 'nm-loading',
	template: `
		<p><i class="fa fa-spin fa-spinner"></i> Loading ...</p>
	`
})
export class NmLoading {}


// WEBPACK FOOTER //
// ./src/widgets/loading/loading.ts